module.exports = __webpack_public_path__ + "static/testimonial_bg_shap-87d0684dab92a92eb702810077756814.png";